import * as React from "react";
import { ContentHeaderBar } from '@/modules/settings/components/ContentHeaderBar'

type Props = {
    className?: string;
    title?: string;
    foldable?: boolean;
    folded?: boolean;
    onToggleFold?: () => void;
    children?: React.ReactNode;
    actions?: React.ReactNode;
}

export const FieldsetSection = ({ className, title, foldable, folded, onToggleFold, children, actions }: Props) => {
    return (
        <div className="tw-bg-base">
            <ContentHeaderBar title={title}>
                {actions}
            </ContentHeaderBar>
            {/* <div className="tw-bg-neutral tw-text-secondary tw-p-2">
                {title && <h2 className="tw-text-lg mb-0">{title}</h2>}
                {actions && <div className="actions">{actions}</div>}
            </div> */}
            <div>
                {children}
            </div>
        </div>
    )
}
